import { styles as commonStyles } from '../../assets/common.scss';
import { styles as flexboxHelpersStyles } from '../../assets/flexbox-helpers.scss';

export const templatePoliciesSelector = document.createElement('template');

templatePoliciesSelector.innerHTML = `
  <style>${commonStyles}</style>
  <style>${flexboxHelpersStyles}</style>
  <div class="wrapper">
<gz-enum-filter id="policiesSelectorDropdown"> </gz-enum-filter>
  </div>
`;
